import { queryWithoutParam } from '@insify/funnel-components';

const AUTH_QUERY = 'auth';

export const removeAuthFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has(AUTH_QUERY)) {
    const queryWithoutAuth = queryWithoutParam(params, AUTH_QUERY);
    window.history.replaceState(null, document.title, window.location.pathname + queryWithoutAuth);
  }
};

export const extractEmailAndLoginTokenFromURL = (authParam: string) => {
  const [emailEncoded, loginToken] = authParam.split(',');
  if (!loginToken) return;

  const email = decodeURIComponent(emailEncoded);
  return { email, loginToken };
};
